import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import posthog from 'posthog-js'

posthog.init(environment.posthog.key, {
  api_host: environment.posthog.host,
  ui_host: "https://eu.i.posthog.com",
  defaults: '2026-01-30',
  disable_session_recording: !environment.production,
  custom_blocked_useragents: [], // evita che PostHog blocchi eventi dalla WebView
  // per non far funzionare posthog in modalità di sviluppo
  opt_out_capturing_by_default: !environment.production,
  advanced_disable_flags: !environment.production,
  disable_external_dependency_loading: !environment.production,
});

posthog.register({
  platform: "mobile-app",
  source: "ionic-user-app",
  $app_name: "MyVet",
  $app_namespace: "it.myvet.app",
  $app_version: environment.appVersion,// sovrascrive "web" come library
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
